import React from 'react'

import { RouteOverrideConfig } from '../routes/routeComponents'
import { RouteConfig } from '../routes/routes'

export type AppConfig = {
  routes: RouteConfig
  routesComponentConfig: RouteOverrideConfig
}

export const DefaultAppConfig: AppConfig = {
  routes: {},
  routesComponentConfig: {}
}

export const AppConfigContext = React.createContext<AppConfig>(DefaultAppConfig)
